var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileViewCambriLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 182,
    height: 41,
    viewBox: "0 0 182 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.0148 29.7419L35.3379 32.023C35.3093 32.0374 35.2835 32.0574 35.2606 32.0775C35.2491 32.0718 35.2405 32.0603 35.2262 32.0546L30.4376 29.7219C30.1768 29.5958 29.873 29.7849 29.873 30.0744V34.7426C29.873 35.032 30.1768 35.2212 30.4376 35.0951L35.2262 32.7624C35.2376 32.7567 35.2491 32.7481 35.2606 32.7395C35.2835 32.7595 35.3093 32.7767 35.3379 32.7939L40.0148 35.075C40.2985 35.2126 40.628 35.0062 40.628 34.691V30.1317C40.6251 29.8107 40.2956 29.6044 40.0148 29.7419Z",
    fill: "url(#paint0_linear_2051_2925)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3294 22.6073C20.6256 22.6073 21.6764 20.9804 21.6764 18.9735C21.6764 16.9667 20.6256 15.3398 19.3294 15.3398C18.0332 15.3398 16.9824 16.9667 16.9824 18.9735C16.9824 20.9804 18.0332 22.6073 19.3294 22.6073Z",
    fill: "url(#paint1_linear_2051_2925)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6616 8.17227C44.5755 9.09216 43.369 9.57646 42.2428 9.81145H21.5209C20.9134 9.81145 20.366 10.0579 19.9677 10.4534C19.4118 11.0093 19.3516 11.7343 19.3258 12.0066C19.3115 12.1671 19.3086 12.339 19.3086 12.6857C19.3086 12.9895 19.3172 13.1443 19.3258 13.4967C19.3315 13.7031 19.3344 13.9982 19.3344 14.3593C19.7929 14.4138 20.624 14.5828 21.3576 15.2047C22.7503 16.3882 22.6901 18.2824 22.6643 19.1393C22.6385 19.9703 22.5812 21.7614 21.2 22.879C20.5237 23.4264 19.7843 23.6069 19.3315 23.6728C19.3287 23.8075 19.3229 24.0081 19.3229 24.2546C19.3229 24.5526 19.3287 24.779 19.3315 24.8105C19.363 25.1458 19.4719 26.315 20.409 27.1088C21.1455 27.7335 22.0024 27.7937 22.3204 27.7994H44.6012C46.2519 27.7994 47.5902 26.4612 47.5902 24.8105V14.6573V13.193C47.5959 10.5651 47.6389 7.97167 47.7134 5.4126C47.3609 6.19493 46.7448 7.25524 45.6616 8.17227ZM45.5613 22.7329C45.5613 24.0482 44.4952 25.1143 43.1799 25.1143H28.9545C27.6392 25.1143 26.5731 24.0482 26.5731 22.7329V14.6115C26.5731 13.7346 27.2838 13.0239 28.1607 13.0239H43.1799C44.4952 13.0239 45.5613 14.0899 45.5613 15.4053V22.7329Z",
    fill: "url(#paint2_linear_2051_2925)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5601 33.3527C60.3386 33.3527 55.5586 28.5383 55.5586 20.8697C55.5586 13.1667 60.3386 8.38672 67.5601 8.38672C70.1393 8.38672 72.4433 9.00571 74.3003 10.2093V14.9893C73.1654 11.2066 70.7583 9.38398 67.5601 9.38398C63.1928 9.38398 60.0979 12.8228 60.0291 20.6634C59.9259 28.6071 62.9865 32.3554 67.4226 32.321C70.5175 32.321 73.1311 30.4297 74.3003 26.3375V31.5301C72.4433 32.6993 70.1393 33.3527 67.5601 33.3527Z",
    fill: "url(#paint3_linear_2051_2925)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M86.155 22.3167C85.9142 20.1159 84.745 18.3277 82.8193 18.3277C80.6872 18.3277 79.6556 20.5285 79.0709 22.4887L76.4574 20.7005C77.661 19.0842 80.0338 17.1929 83.5071 17.1929C87.3586 17.1929 89.9721 19.4625 89.9721 23.1421V30.9482C89.9721 31.6016 90.0752 32.083 90.5911 32.083C91.0381 32.083 91.1757 31.7048 91.382 31.0858H91.7603C91.4508 32.5301 90.9693 33.3554 89.3875 33.3554C88.3214 33.3554 87.0491 32.9771 86.4645 31.636C84.8482 32.6676 82.9568 33.3554 80.584 33.3554C77.1452 33.3554 75.4258 31.8767 75.4258 29.8134C75.4258 26.0307 81.375 23.6923 86.155 22.3167ZM83.2319 31.3265C84.3324 31.3265 85.3296 31.1202 86.2237 30.7075C86.1894 30.5356 86.1893 30.3292 86.1893 30.0885V22.9701C83.0944 24.1393 79.2085 26.2714 79.2085 28.6442C79.2085 30.12 80.756 31.3265 83.2319 31.3265Z",
    fill: "url(#paint4_linear_2051_2925)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.471 32.4584L100.746 32.5959V32.8367H91.9082V32.5959L92.1833 32.4584C93.5588 31.7706 94.4186 30.3263 94.4186 28.8476V22.7265C94.4186 21.2478 93.5588 19.7691 92.1833 19.1157L91.9082 18.9781V18.703C94.3842 18.5655 95.7597 18.3592 98.2013 17.7058V18.9094C99.3017 17.9465 100.78 17.1899 103.05 17.1899C106.042 17.1899 107.796 18.4967 108.518 20.4568C109.653 18.875 111.303 17.1899 114.708 17.1899C118.972 17.1899 120.657 19.7691 120.657 23.1391V28.8476C120.657 30.3263 121.517 31.7706 122.892 32.4584L123.167 32.5959V32.8367H114.329V32.5959L114.605 32.4584C115.98 31.7706 116.874 30.3263 116.874 28.8476V23.1391C116.874 20.5944 115.636 18.3248 113.057 18.3248C111.063 18.3248 109.756 19.6659 108.724 21.179C108.896 21.798 108.965 22.4514 108.965 23.1391V28.8476C108.965 30.3263 109.859 31.7706 111.2 32.4584L111.475 32.5959V32.8367H102.672V32.5959L102.947 32.4584C104.288 31.7706 105.182 30.3263 105.182 28.8476V23.1391C105.182 20.5944 103.979 18.3248 101.365 18.3248C100.058 18.3248 99.061 18.9094 98.2013 19.7691V28.8476C98.2013 30.3263 99.0954 31.7706 100.471 32.4584Z",
    fill: "url(#paint5_linear_2051_2925)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M123.85 13.8918C123.85 12.4131 122.99 10.9344 121.615 10.281L121.34 10.1435V9.90275C123.816 9.7308 125.191 9.52447 127.633 8.87109V20.5631C128.871 18.3967 130.522 17.1931 133.066 17.1931C137.09 17.1931 140.116 20.2193 140.116 25.2743C140.116 30.3294 137.09 33.3556 132.207 33.3556C130.728 33.3556 129.249 32.8398 128.046 32.152C127.495 31.8425 126.945 31.705 126.395 31.705C125.879 31.705 125.363 31.8425 124.916 32.152L123.85 32.8398V13.8918ZM127.633 24.7929C127.908 30.2951 129.903 32.5991 132.619 32.3927C135.233 32.1864 136.746 29.7792 136.402 25.068C136.058 20.2537 134.132 18.3279 132.103 18.3279C131.519 18.3279 129.249 18.1903 127.633 22.0762V24.7929Z",
    fill: "url(#paint6_linear_2051_2925)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M148.815 32.4584L149.09 32.5959V32.8367H140.252V32.5959L140.527 32.4584C141.903 31.7706 142.762 30.3263 142.762 28.8476V22.7265C142.762 21.2478 141.903 19.7691 140.527 19.1157L140.252 18.9781V18.703C142.728 18.5655 144.103 18.3592 146.545 17.7058V20.3193C147.542 18.7374 148.918 17.1899 152.116 17.1899C153.079 17.1899 153.939 17.3619 154.695 17.6026L153.216 20.9727C152.701 19.7691 151.772 19.0813 150.259 19.0813C148.333 19.0813 147.37 20.1473 146.545 21.4541V28.8476C146.545 30.3263 147.439 31.7706 148.815 32.4584Z",
    fill: "url(#paint7_linear_2051_2925)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M160.715 28.8472C160.715 30.3259 161.609 31.7702 162.985 32.458L163.26 32.5955V32.8362H154.422V32.5955L154.697 32.458C156.073 31.7702 156.932 30.3259 156.932 28.8472V22.7261C156.932 21.2474 156.073 19.7687 154.697 19.1153L154.422 18.9777V18.7026C156.898 18.5651 158.273 18.3587 160.715 17.7054V28.8472ZM156.554 11.8966C156.554 10.5554 157.482 9.62695 158.824 9.62695C160.165 9.62695 161.093 10.5554 161.093 11.8966C161.093 13.2377 160.165 14.1662 158.824 14.1662C157.482 14.1662 156.554 13.2377 156.554 11.8966Z",
    fill: "url(#paint8_linear_2051_2925)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5982 20.0764C32.6222 20.0764 33.4524 19.2463 33.4524 18.2223C33.4524 17.1983 32.6222 16.3682 31.5982 16.3682C30.5743 16.3682 29.7441 17.1983 29.7441 18.2223C29.7441 19.2463 30.5743 20.0764 31.5982 20.0764Z",
    fill: "url(#paint9_linear_2051_2925)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M40.798 20.0764C41.8093 20.0764 42.6292 19.2566 42.6292 18.2452C42.6292 17.2339 41.8093 16.4141 40.798 16.4141C39.7866 16.4141 38.9668 17.2339 38.9668 18.2452C38.9668 19.2566 39.7866 20.0764 40.798 20.0764Z",
    fill: "url(#paint10_linear_2051_2925)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4877 22.8163C37.2843 23.0226 37.0092 23.3035 36.5908 23.3092C36.1838 23.3178 35.9001 23.057 35.7024 22.8794C35.3786 22.5842 34.9716 22.0139 35.155 21.6987C35.2382 21.5554 35.413 21.478 35.5763 21.478C36.2555 21.4838 36.9346 21.4895 37.6167 21.4952C37.7284 21.5153 37.8889 21.5611 37.9692 21.693C38.164 22.011 37.7256 22.5756 37.4877 22.8163Z",
    fill: "url(#paint11_linear_2051_2925)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2051_2925",
    x1: 29.2892,
    y1: 38.3434,
    x2: 48.2556,
    y2: 19.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2051_2925",
    x1: 17.1672,
    y1: 21.1377,
    x2: 30.5654,
    y2: 7.73943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2051_2925",
    x1: 22.6034,
    y1: 29.429,
    x2: 47.1103,
    y2: 4.92211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2051_2925",
    x1: 58.5368,
    y1: 29.6751,
    x2: 158.854,
    y2: -70.6422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2051_2925",
    x1: 77.3612,
    y1: 33.0618,
    x2: 127.835,
    y2: -17.4122,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2051_2925",
    x1: 91.4333,
    y1: 41.875,
    x2: 139.519,
    y2: -6.21086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2051_2925",
    x1: 102.544,
    y1: 47.6769,
    x2: 149.881,
    y2: 0.340123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2051_2925",
    x1: 112.783,
    y1: 57.659,
    x2: 163.509,
    y2: 6.93236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2051_2925",
    x1: 118.508,
    y1: 63.2619,
    x2: 171.331,
    y2: 10.4392,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2051_2925",
    x1: 26.0235,
    y1: 23.7955,
    x2: 40.1133,
    y2: 9.70566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2051_2925",
    x1: 35.5802,
    y1: 23.6396,
    x2: 44.6069,
    y2: 14.3044,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2051_2925",
    x1: 34.5307,
    y1: 24.1025,
    x2: 40.5395,
    y2: 17.8884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8730F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#952FD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.917,
    stopColor: "#B92D8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BE2D80"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileViewCambriLogo);
export default __webpack_public_path__ + "static/media/mobile_view_cambri_logo.30a71f5e704aea967276b5786b98c9ca.svg";
export { ForwardRef as ReactComponent };